import Vue from 'vue'
import Router from 'vue-router'
import StMain from './components/main/st-main.vue'

const PAGES = process.env.PAGES

Vue.use(Router)

const routes = []

Object.entries(PAGES).forEach(([name, page]) => {
  routes.push({
    path: '/' + (page.filename || (name + '.html')),
    name,
    component: StMain,
    meta: page.resource
  })
})

routes.push({
  path: '*',
  redirect: '/index.html'
})

export default new Router({
  mode: 'history',
  base: getBasePath(window.location.pathname),
  linkActiveClass: 'current',
  routes
})

function getBasePath (path) {
  const splitted = path.split('/')
  splitted[splitted.length - 1] = ''
  return splitted.join('/')
}
